import axios, { AxiosInstance } from 'axios';

import authHeaderInterceptor from './authHeaderInterceptor';
import refreshTokenInterceptor from './refreshTokenInterceptor';

let http: AxiosInstance;

export default function client() {
  return http || (http = _buildClient());
}

function _buildClient() {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '',
  });

  instance.interceptors.request.use(authHeaderInterceptor);
  instance.interceptors.response.use(undefined, refreshTokenInterceptor);

  return instance;
}
